import { useSyncExternalStore, useCallback } from "react";
import { ES_EN } from "@/lib/i18n/es_en";
import { EN_ES } from "@/lib/i18n/en_es";
import { IGUALES } from "@/lib/i18n/iguales";

export const CLAVE_IDIOMA = "leonas_idioma";
const IDIOMAS = ["en", "es"];

const leer = () => {
  try {
    const v = localStorage.getItem(CLAVE_IDIOMA);
    return IDIOMAS.includes(v) ? v : "en";
  } catch (e) {
    return "en";
  }
};

let actual = leer();
const oyentes = new Set();
if (typeof document !== "undefined") document.documentElement.lang = actual;

export const getIdioma = () => actual;

export function setIdioma(nuevo) {
  if (!IDIOMAS.includes(nuevo) || nuevo === actual) return;
  actual = nuevo;
  try {
    localStorage.setItem(CLAVE_IDIOMA, nuevo);
  } catch (e) {
    /* sin almacenamiento */
  }
  document.documentElement.lang = nuevo;
  oyentes.forEach((f) => f());
  window.dispatchEvent(new Event("leonas:idioma"));
}

const suscribir = (f) => {
  oyentes.add(f);
  return () => oyentes.delete(f);
};

const IGUALES_SET = new Set(IGUALES);

// Traduce un texto escrito en el código (en español o en inglés) al idioma elegido.
export function t(texto, vars) {
  if (typeof texto !== "string") return texto;
  const [, pre, core, post] = texto.match(/^(\s*)([\s\S]*?)(\s*)$/);
  let r = core;
  if (!IGUALES_SET.has(core)) {
    const mapa = actual === "en" ? ES_EN : EN_ES;
    if (mapa[core] != null) r = mapa[core];
  }
  r = pre + r + post;
  return vars ? r.replace(/\{(\w+)\}/g, (m, k) => (k in vars && vars[k] != null ? vars[k] : m)) : r;
}

// Los componentes que lo usan se vuelven a dibujar al cambiar el idioma (sin remontar la app).
export function useT() {
  const idioma = useSyncExternalStore(suscribir, getIdioma);
  const set = useCallback((i) => setIdioma(i), []);
  return { t, idioma, setIdioma: set };
}
